/**
 * Enum representing different allergens
 * Aligned with backend AllergenEnum codes
 */
export enum Allergens {
    GLUTEN = 'GLU',      // Contains gluten
    CRUSTACEANS = 'CRU', // Contains crustaceans
    EGGS = 'EGG',        // Contains eggs
    FISH = 'FSH',        // Contains fish
    PEANUTS = 'PNT',     // Contains peanuts
    SOYBEANS = 'SOY',    // Contains soybeans
    MILK = 'MLK',        // Contains milk
    TREE_NUTS = 'NUT',   // Contains tree nuts
    CELERY = 'CEL',      // Contains celery
    MUSTARD = 'MUS',     // Contains mustard
    SESAME = 'SES',      // Contains sesame seeds
    SULPHITES = 'SUL',   // Contains sulphites
    LUPIN = 'LUP',       // Contains lupin
    MOLLUSCS = 'MOL'     // Contains molluscs
}
